export default {
    PROTOCOLO_NA_FILA_AGUARDANDO_INICIO_DO_PROCESSAMENTO: 1,
    SERVIDOR_INICIOU_PROCESSAMENTO_PROTOCOLO: 2,
    PROCESSAMENTO_FINALIZADO_SEM_INCONSISTENCIA: 3,
    PROCESSAMENTO_FINALIZADO_COM_INCONSISTENCIA: 4,
    ERRO_INTERNO_SERVIDOR: 5,
}